<template>
  <div class="form-filter">
    <div class="form-block">
      <div class="flex some-inputs m-b-8">
        <div class="flex flex-col m-r-20 input-container">
          <label class="small-label">Название воркбука</label>
          <SceletonInput :is-loading="isLoadingData">
            <InputText
              id="slug"
              placeholder="Введите значение"
              v-model="workbook.client_workbook.name"
              :invalid="isInvalidForm && workbook.client_workbook.name == ''"
            />
          </SceletonInput>
        </div>
        <div class="flex flex-col input-container">
          <label class="small-label">Организация</label>
          <SceletonInput :is-loading="isLoadingData">
            <CatalogDataSingleInput
              :useIdOnly="true"
              selectType="organization"
              :is-invalid="
                isInvalidForm &&
                workbook.client_workbook.organization_id == null
              "
              :isSegmentSetted="false"
              :modelValue="workbook.client_workbook.organization_id"
              @update:modelValue="
                ($event) => (workbook.client_workbook.organization_id = $event)
              "
            ></CatalogDataSingleInput>
          </SceletonInput>
        </div>
      </div>
      <div class="toggle-row m-t-10 m-b-8">
        <label class="small-label"
          >Добавлять в демо-аккаунты при их создании</label
        >
        <InputSwitch
          v-model="workbook.client_workbook.include_to_demo_accounts"
          inputId="include_to_demo_accounts"
        />
      </div>

      <div class="flex flex-col fl-1">
        <label for="name" class="small-label">Токен воркбука</label>
        <SceletonInput :is-loading="isLoadingData">
          <Textarea
            autoResize
            :invalid="isInvalidForm && workbook.client_workbook.token == ''"
            v-model="workbook.client_workbook.token"
            rows="5"
            cols="30"
          />
        </SceletonInput>
      </div>
    </div>

    <div
      class="form-block"
      v-for="(dashboard, idx) in workbook.dashboards"
      :key="`dash-${idx}`"
    >
      <div class="flex some-inputs m-b-8">
        <div class="flex flex-col m-r-20 input-container">
          <label class="small-label">Название дашборда</label>
          <SceletonInput :is-loading="isLoadingData">
            <InputText
              id="slug"
              placeholder="Введите значение"
              v-model="dashboard.name"
              :invalid="isInvalidForm && dashboard.name == ''"
            />
          </SceletonInput>
        </div>
        <div class="flex fl-jc-sb fl-1 flex-end">
          <div class="flex flex-col fl-1">
            <label class="small-label">Datalens ID</label>
            <SceletonInput :is-loading="isLoadingData">
              <InputText
                id="slug"
                placeholder="Введите значение"
                v-model="dashboard.datalens_id"
                :invalid="isInvalidForm && dashboard.datalens_id == ''"
              />
            </SceletonInput>
          </div>
          <div
            class="group-button-container flex"
            :class="[idx != workbook.dashboards.length - 1 ? 'hidden' : '']"
          >
            <div
              v-if="workbook.dashboards.length > 1"
              class="delete-button flex flex-center m-l-12"
              @click="deleteDashboard(idx)"
            >
              <span class="pi pi-trash f-s-12"></span>
            </div>
            <div class="add-button flex flex-center" @click="addDashboard(idx)">
              <span class="pi pi-plus"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col fl-1">
        <label for="name" class="small-label">Описание</label>
        <SceletonInput :is-loading="isLoadingData">
          <Textarea
            autoResize
            v-model="dashboard.description"
            rows="5"
            cols="30"
          />
        </SceletonInput>
      </div>

      <div class="flex flex-center m-t-18">
        <label for="name" class="small-label"
          >Роли, которым доступно редактирование (если не указаны, то доступно
          всем):</label
        >
        <div
          v-if="dashboard.roles.length == 0"
          class="add-button flex flex-center"
          @click="addRole(-1, idx)"
        >
          <span class="pi pi-plus"></span>
        </div>
      </div>

      <div
        class="flex flex-col fl-1 m-b-8 role-container"
        v-for="(role, idxr) in dashboard.roles"
        :key="`role-${idxr}`"
      >
        <div class="flex flex-center">
          <div class="flex some-inputs m-t-4 fl-1">
            <div class="flex flex-col m-r-20 input-container">
              <label class="small-label">Департамент</label>
              <Dropdown
                v-model="role.department.id"
                :invalid="isInvalidForm && role.department.id == null"
                optionLabel="name"
                :options="departments"
                optionValue="id"
                placeholder="Выберите значение"
                filter
              ></Dropdown>
            </div>
            <div class="flex input-container flex-end">
              <div class="flex flex-col fl-1">
                <label class="small-label">Роль</label>
                <Dropdown
                  v-model="role.id"
                  :invalid="isInvalidForm && role.department.id == null"
                  optionLabel="name"
                  :options="getRoles(role.department.id)"
                  optionValue="id"
                  :disabled="role.department.id == 0"
                  placeholder="Выберите значение"
                  filter
                ></Dropdown>
              </div>

              <div
                class="group-button-container role flex"
                :class="[idxr != dashboard.roles.length - 1 ? 'hidden' : '']"
              >
                <div
                  class="delete-button flex flex-center m-l-8"
                  @click="deleteRole(idxr, idx)"
                >
                  <span class="pi pi-trash f-s-12"></span>
                </div>
                <div
                  class="add-button flex flex-center"
                  @click="addRole(idxr, idx)"
                >
                  <span class="pi pi-plus"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useDashbordsStore } from "@/store/analytics/dasboards";
import { useOrganizationsStore } from "@/store/dictionaries/organizations";
import { useOrganizationsDictionaryStore } from "@/store/catalog_data/organizations";

import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";

import { areWorkbookFieldsValid } from "@/services/dictionaries/workbooks";
import { rootGetters } from "@/main";
import { insertNewLines } from "@/services/utils/Strings";
import { Department } from "@/store/dictionaries/organizations";
import { Role } from "@/store/analytics/dasboards";

const emit = defineEmits(["setLoading"]);
const route = useRoute();
const router = useRouter();
const store = useDashbordsStore();
const orgStore = useOrganizationsDictionaryStore();
const organizationsStore = useOrganizationsStore();

const workbook = ref({
  client_workbook: {
    name: "",
    token: "",
    tenant: "",
    organization_id: null as null | number,
    include_to_demo_accounts: false,
  },
  dashboards: [
    {
      name: "",
      description: "",
      datalens_id: "",
      roles: [] as Role[],
    },
  ],
});

const isLoadingData = ref(false);
const isInvalidForm = ref(false);
const isWorkbookSetted = computed(() => {
  return Boolean(route.params.id);
});
const departments = ref([] as Department[]);
const isDemoOrganization = ref(false);

const loadOrganizationsWithDemo = () => {
  organizationsStore
    .getOrganizations({ page: 1, per_page: 100, include_demo: true, order_by: "name" })
    .then(() => {
      orgStore.itemList = organizationsStore.organizationsList as any;
    });
};

watch(
  () => workbook.value.client_workbook.organization_id,
  () => {
    if (workbook.value.client_workbook.organization_id)
      organizationsStore
        .getOrganizationBase(workbook.value.client_workbook.organization_id)
        .then((data) => {
          if (data) {
            departments.value = data.departments;
            return;
          }
        });
  },
);

const reload = () => {
  if (isWorkbookSetted.value) {
    isLoadingData.value = true;
    const workbookId = parseInt(route.params.id);
    store
      .getWorkbook(workbookId)
      .then((workbookClone) => {
        if (workbookClone) {
          isDemoOrganization.value = Boolean((workbookClone as any).is_demo);
          if (isDemoOrganization.value) {
            loadOrganizationsWithDemo();
          }

          workbook.value.client_workbook.name = workbookClone.name;
          workbook.value.client_workbook.tenant = workbookClone.tenant;
          workbook.value.client_workbook.token = "************";
          workbook.value.client_workbook.organization_id =
            workbookClone.organization_id;
          workbook.value.client_workbook.include_to_demo_accounts =
            workbookClone.include_to_demo_accounts || false;
          workbook.value.dashboards = workbookClone.dashboards;
        }
      })
      .finally(() => {
        isLoadingData.value = false;
      });
  }
};

onMounted(() => {
  reload();
});

const getRoles = (depId: number) => {
  const dep = departments.value.find((item) => item.id == depId);
  if (dep && dep.roles) return dep.roles;
  return [];
};

const addDashboard = (idx: number) => {
  workbook.value.dashboards.splice(idx + 1, 0, {
    name: "",
    description: "",
    datalens_id: "",
    roles: [],
  });
};

const deleteDashboard = (idx: number) => {
  workbook.value.dashboards.splice(idx, 1);
};

const createWorkbook = () => {
  if (!areWorkbookFieldsValid(workbook.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены.`,
    );
    return;
  }

  const workbookCopy = { ...workbook.value };

  let token = insertNewLines(
    workbook.value.client_workbook.token,
    "-----BEGIN RSA PRIVATE KEY-----",
  );
  token = insertNewLines(token, "-----END RSA PRIVATE KEY-----");
  workbookCopy.client_workbook.token = token;

  const org = orgStore.itemList.find(
    (e) => e.id == workbook.value.client_workbook.organization_id,
  );
  if (org) {
    workbookCopy.client_workbook.tenant = org.tenant;
  } else if (isWorkbookSetted.value && isDemoOrganization.value) {
    workbookCopy.client_workbook.tenant = workbook.value.client_workbook.tenant;
  } else {
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Тенант организации не найден.`,
    );
    return;
  }

  workbookCopy.dashboards.forEach((el) => {
    const uniqueRoleIds = Array.from(new Set(el.roles.map((role) => role.id)));
    el["roles_ids"] = uniqueRoleIds;
  });

  if (workbook.value.client_workbook.token == "************") {
    delete (workbookCopy.client_workbook as any).token;
  }

  emit("setLoading", true);
  if (!isWorkbookSetted.value) {
    performOrganizationAction(() => store.createWorkbook(workbookCopy));
  } else {
    performOrganizationAction(() =>
      store.updateWorkbook(workbookCopy, parseInt(route.params.id)),
    );
  }
};

const performOrganizationAction = (action: any) => {
  const handleCampaignSuccess = () => {
    router.push({ name: "workbooks" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  action()
    .then(handleCampaignSuccess)
    .catch((err: any) => {
      if (err.response && err.response.status == 409)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
      if (err.response && err.response.status == 403)
        rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
    })
    .finally(() => {
      emit("setLoading", false);
    });
};

const addRole = (idxRole: number, idxDashboard: number) => {
  workbook.value.dashboards[idxDashboard].roles.splice(idxRole + 1, 0, {
    id: 0,
    department: { id: 0 },
  });
};

const deleteRole = (idxRole: number, idxDashboard: number) => {
  workbook.value.dashboards[idxDashboard].roles.splice(idxRole, 1);
};

defineExpose({
  createWorkbook,
});
</script>

<style lang="scss" scoped>
.form-filter {
  max-width: 100%;
  width: 100%;
  padding-bottom: 40px;
  min-width: 500px;
}

.form-block-title {
  margin-bottom: 8px;
}

.form-block:hover .group-button-container.hidden {
  display: flex;
}

.small-label {
  color: #a19cab;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.43rem;
  padding-bottom: 4px;
  padding-left: 4px;
}

.group-button-container.hidden {
  display: none;
}

.delete-button {
  border-radius: 5px;
  background: #f7f7fd;
  width: 32px;
  height: 32px;
  padding-left: 9px;
  cursor: pointer;
  margin-bottom: 2px;

  &:hover {
    background-color: #fafaff;
  }
}

.add-button {
  background-color: #dbdaf9;
  border-radius: 5px;
  padding: 3px 9px;
  cursor: pointer;
  height: 32px;
  margin-left: 12px;
  margin-bottom: 1px;

  &:hover {
    background-color: #d4d3f8;
    outline-color: transparent;
  }
}

.f-s-12 {
  font-size: 12px;
}

.sub-block {
  padding: 12px;
  background-color: #f7f7fd;
  border: 1px solid #d0d0d6;
  border-radius: 6px;
}

.some-inputs {
  max-width: 100%;
}

.input-container {
  max-width: calc(50% - 4px);
  width: calc(50% - 4px);
}

.toggle-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
</style>
